import useCart from 'hooks/use-cart';
import useUI from 'hooks/use-ui';

export function useHasAssignedDispensaryToCart(): boolean {
  const { dispensary } = useCart();

  return Boolean(dispensary?.cName);
}

export function useHasSelectedDispensaryToView(): boolean {
  const { isMarketplaceDispensary } = useUI();
  const { dispensary } = useCart();

  return isMarketplaceDispensary && !dispensary?.cName;
}
